module.exports = __webpack_public_path__ + "img/Mexico.3493a290.png";